import * as React from "react";
import { PageModel, PanelModelBase } from "survey-core";
import { SurveyElementBase } from "./reactquestion_element";
import { SurveyPanelBase } from "./panel-base";
import { TitleElement } from "./components/title/title-element";
import { SurveyElementErrors } from "./reactquestion";
import { ReactElementFactory } from "./element-factory";

export class SurveyPage extends SurveyPanelBase {
  constructor(props: any) {
    super(props);
  }
  protected getPanelBase(): PanelModelBase {
    return this.props.page;
  }
  public get page(): PageModel {
    return this.panelBase as PageModel;
  }

  protected renderElement(): React.JSX.Element {
    var title = this.renderTitle();
    var description = this.renderDescription();
    var rows = this.renderRows(this.panelBase.cssClasses);
    const errors = (
      <SurveyElementErrors
        element={this.panelBase}
        cssClasses={this.panelBase.cssClasses}
        creator={this.creator}
      />
    );
    var header: any = null;
    if (this.page.hasTitle || this.page._showDescription) {
      header = (
        <div className={this.page.cssHeader}>
          {title}
          {description}
        </div>
      );
    }
    return (
      <div ref={this.rootRef} className={this.page.cssRoot}>
        {header}
        <div className={this.page.cssContent}>
          {errors}
          {rows}
        </div >
      </div >
    );
  }
  protected renderTitle(): React.JSX.Element {
    return <TitleElement element={this.page}></TitleElement>;
  }
  protected renderDescription(): React.JSX.Element | null {
    if (!this.page._showDescription) return null;
    var text = SurveyElementBase.renderLocString(this.page.locDescription);
    return (
      <div className={this.panelBase.cssClasses.page.description}>{text}</div>
    );
  }
}

ReactElementFactory.Instance.registerElement("sv-page", (props) => {
  return React.createElement(SurveyPage, props);
});